import React from "react";
import Disclaimer from "./Disclaimer";
import "./AreaOfPractise.css";
import "./NavBar.css";
import "./App.css"; // Import the CSS file for styling
import Footer from "./footer";
import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

// Import your components here (optional)
//import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import Blog from "./Blog";
import Admin from "./Admin";
import AccidentalClaimCases from "./AccidentalClaimCases";
import ArbitrationMediation from "./ArbitrationMediation";
import ChequeBouncingCases from "./ChequeBouncingCases";
import CivilLaw from "./CivilLaw";
import ConsumerProtectionLaw from "./ConsumerProtectionLaw";
import CorporateCommercialLaw from "./CorporateCommercialLaw";
import CriminalLaw from "./CriminalLaw";
import DebtRecoveryCases from "./DebtRecoveryCases";
import DomesticFamilyLaw from "./DomesticFamilyLaw";
import LabourIndustrialLaw from "./LabourIndustrialLaw";
import RealEstateMatters from "./RealEstateMatters";
import TaxationLaw from "./TaxationLaw";
import Internship from "./Internship";
import Dashboard from "./Dashboard";

function App() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return (
    <Router>
      <Disclaimer />
      <div>
        <nav className="nav-bar">
          <h>Legal Experts India</h>

          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <div className="dropdown-container">
            <div className="nav-bar">
              <a to="/nav-bar" className="area-of-practice-tab">
                Area of Practice
              </a>
              <a className="dropdown-menu">
                <li>
                  <Link to="/AccidentalClaimCases">Accidental Claim Cases</Link>
                  <Link to="/ArbitrationMediation">
                    Arbitration and Mediation
                  </Link>

                  <Link to="/ChequeBouncingCases">Cheque Bouncing Cases</Link>

                  <Link to="/CivilLaw">Civil Law</Link>

                  <Link to="/ConsumerProtectionLaw">
                    Consumer Protection Law
                  </Link>

                  <Link to="/CorporateCommercialLaw">
                    Corporate & Commercial Law
                  </Link>

                  <Link to="/CriminalLaw">Criminal Law</Link>

                  <Link to="/DebtRecoveryCases">Debt Recovery Cases</Link>

                  <Link to="/DomesticFamilyLaw">Divorce and Family Law</Link>

                  <Link to="/LabourIndustrialLaw">
                    Labour and Industrial Law
                  </Link>

                  <Link to="/RealEstateMatters">Real Estate Matters</Link>

                  <Link to="/TaxationLaw">Taxation Law</Link>
                </li>
              </a>
            </div>
          </div>
          <Link to="/Internship">Internship</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/Blog">Blog</Link>
          <Link to="/Admin">Login</Link>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Internship" element={<Internship />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Admin" element={<Admin />} />
          <Route path="/Dashboard" element={<Dashboard />} />

          <Route
            path="/AccidentalClaimCases"
            element={<AccidentalClaimCases />}
          />
          <Route
            path="/ArbitrationMediation"
            element={<ArbitrationMediation />}
          />
          <Route
            path="/ChequeBouncingCases"
            element={<ChequeBouncingCases />}
          />
          <Route path="/CivilLaw" element={<CivilLaw />} />
          <Route
            path="/ConsumerProtectionLaw"
            element={<ConsumerProtectionLaw />}
          />
          <Route
            path="/CorporateCommercialLaw"
            element={<CorporateCommercialLaw />}
          />
          <Route path="/CriminalLaw" element={<CriminalLaw />} />
          <Route path="/DebtRecoveryCases" element={<DebtRecoveryCases />} />
          <Route path="/DomesticFamilyLaw" element={<DomesticFamilyLaw />} />
          <Route
            path="/LabourIndustrialLaw"
            element={<LabourIndustrialLaw />}
          />
          <Route path="/RealEstateMatters" element={<RealEstateMatters />} />
          <Route path="/TaxationLaw" element={<TaxationLaw />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
